import { EzNewswireLogo } from 'icons/EzNewswireLogo';
import { Link } from '@/app_components/common/Link';

interface InListCTAProps {
    ctaUrl: string;
}

export const InListCTA = ({ ctaUrl }: InListCTAProps) => {
    return (
        <div
            className='flex flex-col items-center p-6 lg:p-8 xl:p-10 gap-6 rounded-sm bg-accent-inverse shadow-[0_0_24px_0_rgba(17,17,17,0.04)] font-graphik-compact'
            data-cy='ez-newswire-press-release-list-inline-cta'
        >
            <div className='flex flex-col items-center gap-4'>
                <EzNewswireLogo />
                <div className='text-primary text-center typography-default font-normal'>
                    Subscribe today for exclusive business insights.
                </div>
            </div>
            <Link
                href={`${ctaUrl}&utm_content=incontent_link`}
                target='_blank'
                className='px-8 py-4 rounded-full button-primary button-primary-hover button-text-primary text-base leading-4 font-medium'
                data-cy='ez-newswire-press-release-list-inline-cta-button'
            >
                Subscribe Now
            </Link>
        </div>
    );
}